import React from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";

const PaymentStatusBox = ({image, type, amount, total, fee, currency, date}) => {
    const auth = useSelector((state) => state.auth);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();


    return (
        <div>
            <div className="payment-status-container">

                <div className="payment-image"><img src={image} alt=""/></div>
                <div className="payment-status-header">
                    <h1 className={`${type === 'success' ? 'success' : (type === 'failed' ? 'failed' : 'success')}`}>پرداخت موفق</h1>
                    <h5>پرداخت شما با موفقیت { type==='success' ? "انجام شد" : (type === 'failed' ? 'انجام نشد' : 'انجام شد')}</h5>
                </div>

                <div className="payment-status-values">
                    <div className="d-flex flex-row justify-content-between payment-value-item">
                        <div className="key">مبلغ فاکتور</div>
                        <div className="value">{amount}</div>
                    </div>
                    <div className="d-flex flex-row justify-content-between payment-value-item">
                        <div className="key">کارمزد درگاه</div>
                        <div className="value">{fee}</div>
                    </div>
                    <div className="d-flex flex-row justify-content-between payment-value-item">
                        <div className="key">تاریخ تراکنش</div>
                        <div className="value">{date}</div>
                    </div>
                    <div className="d-flex flex-row justify-content-between payment-value-item">
                        <div className="key">ارز پرداخت شده</div>
                        <div className="value">{currency}</div>
                    </div>
                </div>
                <div className="payment-divider"></div>
                <div className="payment-status-values">
                    <div className="d-flex flex-row justify-content-between">
                        <div className="key">مجموع پرداخت</div>
                        <div className="value">{total}</div>
                    </div>
                </div>
                <div className="payment-divider"></div>
                <div className="form-submit-btn"  onClick={ () => {
                    navigate('/dashboard')
                }}>
                    بازگشت به صحفه اصلی
                </div>
            </div>
        </div>

    );
};

export default PaymentStatusBox;
